export const ONBOARDING_STATES = {
  initialized: 'initialized',
  signedup: 'signedup',
  deactivated: 'deactivated',
}
